export default __webpack_public_path__ + "static/use-2-pt-46d3a4992b315633548902f25a734c10.png";